/*
 *  ZAITEC CONFIDENTIAL
 *  __________________
 *
 * [2019] - [2020] zaiTEC Logixs Ltd
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of  zaiTEC Logixs Ltd and its suppliers,if any.
 *  The intellectual and technical concepts contained herein are proprietary to zaiTEC Logixs Ltd, and are protected by
 *  trade secret or copyright law.Dissemination of this information or reproduction of this material is strictly forbidden
 *  unless prior written permission is obtained from  zaiTEC Logixs Ltd.
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuardService } from './authGuard.service';

@Injectable()
export class AuthGuard {
  isLoggedIn: boolean = false;

  constructor(private router: Router, private authGuardService: AuthGuardService) {
    // ✅ Subscribe to get the latest value
    this.authGuardService.isLoggedIn$.subscribe((status) => {
      this.isLoggedIn = status;
    });
    console.log('AuthGuard constructor' + this.isLoggedIn);
  }

  canActivate(): boolean {
    this.authGuardService.isLoggedIn$.subscribe((status) => {
      this.isLoggedIn = status;
    });

    if (!this.isLoggedIn) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}
